// extracted by css-extract-rspack-plugin
export default {"iframe":"JivJGwbK","iframeFullScreen":"S23z8u4G"};